<template>
  <div class="anz-advert" :id="advert.divId"></div>
</template>

<script>
import useAdvertManager, { Advert } from '@/composables/advert/advertManager'

export default {
  name: 'AdvertPosition',
  components: {},
  props: {
    advert: {
      type: Advert,
      required: true,
    },
  },
  mounted() {
    const { propagateAdv } = useAdvertManager()

    propagateAdv(this.advert)
  },
}
</script>
